import React, { useEffect } from 'react';

export default function ProjectHandoverForm() {
  useEffect(() => {
    // Redirect to the static HTML file in the public folder
    window.location.href = '/project-handover.html';
  }, []);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>Redirecting to Project Handover Form...</p>
    </div>
  );
}
